
enum PricingSubmissionState {
	PENDING = 'PENDING',
	IN_PROGRESS = 'IN_PROGRESS',
	SUCCESS = 'SUCCESS',
	FAILED = 'FAILED',
}

export default PricingSubmissionState;
